<template>
  <div>
    <div v-if="serie_status != 3" class="filter-container">
      <div class="fechas-container">
        <label class="panel-text-section-dark">Desde: <input class="filter-date" name="init-date" v-model="initDate" type="date" @change="filter()"></label>
        <div class="end-date"><label class="panel-text-section-dark">Hasta: <input class="filter-date" name="end-date" v-model="endDate" type="date" @change="filter()"></label></div>
      </div>
      <div class="fechas-container">
        <label class="filter-string panel-text-section-dark">Filtrar por palabras: <input class="filter-string" name="filter-string" v-model="stringFiltered" type="text" @keyup="filter()"></label>
      </div>
      <p style="margin-top: 1.5rem;" class="panel-text-section-dark">Resultados Mostrados: <span class="resultados">{{campaign_datas_filtered.length}}</span></p>
      <div class="button-container"><button class="new-button" @click="deleteFilters()">Borrar Filtros</button></div>
    </div>
    <div v-else>
      <div class="info-container m-4">
        <img class="info-icon" :src="require('@/assets/icons/info-icon.svg')" alt="Info icon"/> 
          Por favor, espere.
        <img  class="loading-icon" :src="require('@/assets/icons/spinner.gif')" alt="loading"/> 
      </div>
    </div>
  </div>
</template>

<script>
  // Vuex
  import { mapGetters } from 'vuex'

  export default {
    name: 'panelFilter',
    data: function () {
        return {
          initDate: null,
          endDate: null,
          stringFiltered: ""
        }
    },
    computed: {
        ...mapGetters(
            "map_params",{
                campaign_datas_filtered: 'campaign_datas_filtered',
                campaign_datas: 'campaign_datas',
                transect_points: 'transect_points',
                stations_or_density: 'stations_or_density',
                serie_status: 'serie_status',
                transect_status: 'transect_status'
            }
        ),
        campaign_datas_filtered: {
            set (selected_campaign) { this.$store.dispatch('map_params/change_campaign_datas_filtered', selected_campaign); },
            get () { return this.$store.state.map_params.campaign_datas_filtered}
        },
        serie_status: {
            set (status) { this.$store.dispatch('map_params/change_serie_status', status); },
            get () { return this.$store.state.map_params.serie_status }
        },
    },
    mounted () {
        //this.getCampaignDatas()
    },
    watch: {
        'campaign_datas_filtered': function () {
          if(this.serie_status == 4)
              if (this.stations_or_density[3] == 'serie_temp'){
                this.serie_status = 3
                if (this.transect_points.length > 0){
                  this.$store.dispatch('map_params/change_serie_transect_points', this.transect_points)
                }else{
                  this.$store.dispatch('map_params/change_serie_temporal_MM', '')
                }
              }
        },
    },
    methods: {
        getCampaignDatas: function () {
            this.$store.dispatch('map_params/getCampaignDatas')
        },
        filter : function() {
          let globalThis = this
          let tempArray = []
          // Filtrado Fechas
          this.campaign_datas_filtered = [];
          if(globalThis.endDate && globalThis.initDate) {
            this.campaign_datas.map(function(currentValue){
                  if ((globalThis.initDate <= currentValue.date) && (globalThis.endDate >= currentValue.date)) {
                    tempArray.push(currentValue);
                  }
            })} 
          else if (globalThis.endDate) {
            this.campaign_datas.map(function(currentValue){
                  if (globalThis.endDate >= currentValue.date) {
                    tempArray.push(currentValue);
                  }
            })} 
          else if (globalThis.initDate) {
            this.campaign_datas.map(function(currentValue){
                  if (globalThis.initDate <= currentValue.date) {
                    tempArray.push(currentValue);
                  }
            })} 
          else {
            tempArray = this.campaign_datas;
          }
          // Filtrado de Strings
          if(this.stringFiltered){
            tempArray.map(function(currentValue, index){
              if(Object.values(currentValue).includes(globalThis.stringFiltered)){
                globalThis.campaign_datas_filtered.push(currentValue)
              }
            })  
          } 
          else {
            this.campaign_datas_filtered = tempArray;
          }
        },
        deleteFilters: function() {
          this.initDate = null,
          this.endDate = null,
          this.stringFiltered = ""
          this.filter();
        }
    }
  }
</script>

<style scoped>
.filter-container{
  margin: .5rem 1rem 0 1rem;
  overflow: hidden;
}
.filter-title {
  font-weight: bold;
  color: #447998;
  font-size: 0.8rem;
}
.filter-blue {
  color: #447998;
}

.panel-text-section-dark{
  color: #447998;
  font-size: 0.9rem;
  font-weight: bold;
}

.fechas-container{
  display: flex;
}

input {
  display: inline-block;
  width: 150px;
  top: 0.1em;
  color: #447998;
  border: 1px solid #447998;
  border-radius: 5px;
}

label {
  display: inline-block;
  width: 6em;
  margin-right: 0.5em;
  padding-top: 0.5em;
}

.end-date {
  margin-left: 60px;
}

.filter-string {
  width: 250px;
}

.resultados{
  color: #447998;
  font-weight: bold;
}

.button-container{
  padding: 20px;
  display: flex;
  float: right;
}

.new-button {
  background: #cc6b6b;
  font-size: 10px;
  color: #ffffff;
  /* height: 20px; */
  border-radius: 20px;
  border: 1px solid #c95959;
  cursor: pointer;
  font-weight: 400;
  transition: 0.1s;
  opacity: 0.5;
  padding: 8px;
}
.new-button:hover {
    background: #c95959;
    transform: scale(1.1);
    opacity: 1;
}

.info-container {
        /* position: absolute;
        top: 20px;
        left: 20px; */
        background-color: #f4fafe;
        z-index: 1000000;
        color: #447998;
        font-size: 0.9rem;
        padding: 20px;
        border-radius: 25px;
        box-shadow: 0px 3px 3px rgba(0,0,0,0.3);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    .info-icon {
        width: 40px;
        height: 40px;
        margin-right: 20px;
    }
    .loading-icon {
        height: 60px;
        margin-top: -20px;
        margin-bottom: -20px;
        width: 60px;
        margin-right: -6px;
        margin-left: 20px;
    }

</style>



// WEBPACK FOOTER //
// src/components/mapparams/panelFilter.vue